import { tss } from "tss-react/mui";

export const useFooterSectionStyles = tss.withName("FooterSection").create(({ theme }) => ({
    root: {
        backgroundColor: theme.palette.primary[900],
        color: theme.palette.common.white,
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(4),
        paddingLeft: "4%",
        paddingRight: "4%",
    },
    container: {
        maxWidth: "1640px",
        margin: "0 auto",
    },
    brandRow: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    description: {
        color: "rgba(255,255,255,0.7)",
        maxWidth: 380,
        marginBottom: theme.spacing(5),
    },
    columns: {
        display: "grid",
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        gap: theme.spacing(4),
        marginBottom: theme.spacing(5),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr",
        },
    },
    columnTitle: {
        color: "rgba(255,255,255,0.45)",
        fontWeight: 700,
        textTransform: "uppercase" as const,
        letterSpacing: "0.08em",
        fontSize: "0.75rem",
        marginBottom: theme.spacing(2),
    },
    columnLinks: {
        display: "flex",
        flexDirection: "column" as const,
        gap: theme.spacing(1.25),
    },
    columnLink: {
        color: "rgba(255,255,255,0.8)",
        textDecoration: "none",
        fontSize: "0.9rem",
        width: "fit-content",
        "&:hover": {
            color: theme.palette.primary.light,
        },
    },
    bottomBar: {
        borderTop: "1px solid rgba(255,255,255,0.12)",
        paddingTop: theme.spacing(3),
        display: "flex",
        flexWrap: "wrap" as const,
        justifyContent: "space-between",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    copyright: {
        fontSize: "0.75rem",
        color: "rgba(255,255,255,0.5)",
    },
    legalLinks: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap" as const,
        gap: theme.spacing(1),
    },
    legalLink: {
        fontSize: "0.75rem",
        color: "rgba(255,255,255,0.5)",
        textDecoration: "none",
        "&:hover": {
            color: theme.palette.primary.light,
        },
    },
    legalDot: {
        fontSize: "0.75rem",
        color: "rgba(255,255,255,0.3)",
    },
}));
